// @flow

import { merge } from 'lodash';
import defaultAppStyleApp from './app';
import customStyle from './customStyle';

export default merge(defaultAppStyleApp, customStyle);
